import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <path
          fill="#58595B"
          d="M9 41.9h2.4c.4 0 .5-.1.5-.5v-26c0-.4.1-.6.6-.6h39.1c.4 0 .6.1.6.5v26c0 .4.1.5.5.5h2.2c.2 0 .3 0 .3.3.2 2.7-1.6 5.7-4.1 6.8-.7.3-1.5.4-2.3.4H15.5c-3.1 0-5.1-2.3-5.9-4.5-.2-.5-.3-.9-.4-1.4-.2-.5-.2-1-.2-1.5zm23-25.7H13.8c-.4 0-.5.1-.5.5v24.6c0 .4.1.5.5.5h36.4c.4 0 .5-.1.5-.5V16.7c0-.4-.1-.5-.5-.5H32zm0 27.1H10.8c-.2 0-.3 0-.2.3.1.5.2.9.4 1.3 1 1.9 2.4 3.1 4.7 3.1h32.7c.4 0 .8 0 1.2-.1 2-.6 3.1-2 3.6-3.9.2-.6.1-.6-.5-.6-6.9-.1-13.8-.1-20.7-.1z"
        />
        <path
          fill="#231F20"
          d="M28.3 44.8c.7 0 .7 0 .7.9 0 .6 0 .6-.9.6-.5 0-.5 0-.5-.9-.1-.6-.1-.6.7-.6zm8.1.8c0 .7 0 .7-.7.7s-.7 0-.7-.7 0-.7.7-.7c.7-.1.7-.1.7.7zm-4.4.7c-.7 0-.7 0-.7-.7s0-.7.8-.7c.7 0 .7 0 .7.7-.1.7-.1.7-.8.7z"
        />
        <path fill="#BCBEC0" d="M14.7 17.4h34.6v23.4H14.7z" />
      </svg>
    </>
  ),
  'Computer',
  '0 0 120 120'
);
